import once from "lodash/once";
import { YTFetch, getRuntimeApiPrefix } from "@yuntoo/fetch";

/**
 * 请求配置封装
 * 指定baseURL, 切换到新的runtime接口
 */
export const ytFetch = new YTFetch({
  baseURL: getRuntimeApiPrefix(),
});

/**
 * 从html中获取appInfo信息
 */
export const getAppInfo = once(async () => {
  // 用于独立部署, 配合 output 脚本食用
  if (window.__GLOBAL__?.deploymentConfig?.APP_CODE) {
    return await ytFetch.get("/api/app/getOne", {
      appCode: window.__GLOBAL__.deploymentConfig.APP_CODE,
    });
  }
  return window.__GLOBAL__?.appInfo || {};
});
